export default __webpack_public_path__ + "static/media/appInfo.5d3e7492.png";